import { render } from "./SellingPointsList.component.vue?vue&type=template&id=10c9f1ae"
import script from "./SellingPointsList.component.vue?vue&type=script&lang=js"
export * from "./SellingPointsList.component.vue?vue&type=script&lang=js"

import "./SellingPointsList.component.vue?vue&type=style&index=0&id=10c9f1ae&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QItemSection,QIcon,QItemLabel});
